/**
 * @generated SignedSource<<d092d27c8fcf429532efe668ede31810>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectPortfolioPeriodRow_financialNumbers$data = {
  readonly billableActualTimeAndExpenses: number | null;
  readonly totalActualRevenueRecognition: number | null;
  readonly actualCost: number | null;
  readonly actualProfit: number | null;
  readonly actualRevenueProfit: number | null;
  readonly actualMargin: number | null;
  readonly actualRevenueMargin: number | null;
  readonly billablePlannedTimeAndExpenses: number | null;
  readonly plannedRevenue: number | null;
  readonly plannedCost: number | null;
  readonly plannedProfit: number | null;
  readonly plannedRevenueProfit: number | null;
  readonly plannedMargin: number | null;
  readonly plannedRevenueMargin: number | null;
  readonly billableForecastTimeAndExpensesToComplete: number | null;
  readonly totalForecastRevenueToComplete: number | null;
  readonly forecastCostToComplete: number | null;
  readonly forecastProfitToComplete: number | null;
  readonly forecastRevenueProfitToComplete: number | null;
  readonly forecastMarginToComplete: number | null;
  readonly forecastRevenueMarginToComplete: number | null;
  readonly billableTotalTimeAndExpensesAtCompletion: number | null;
  readonly nonBillableTotalTimeAndExpensesAtCompletion: number | null;
  readonly allTotalTimeAndExpensesAtCompletion: number | null;
  readonly totalRevenueRecognition: number | null;
  readonly totalCostAtCompletion: number | null;
  readonly totalProfitAtCompletion: number | null;
  readonly totalRevenueProfitAtCompletion: number | null;
  readonly totalMarginAtCompletion: number | null;
  readonly totalRevenueMarginAtCompletion: number | null;
  readonly baselineRevenue: number | null;
  readonly baselineTimeAndExpenses: number | null;
  readonly baselineCost: number | null;
  readonly baselineProfit: number | null;
  readonly baselineMargin: number | null;
  readonly baselineMinutes: number | null;
  readonly planVsBillableActualTimeAndExpenses: number | null;
  readonly planVsActualCost: number | null;
  readonly planVsActualProfit: number | null;
  readonly planVsActualRevenueProfit: number | null;
  readonly planVsActualRevenueRecognition: number | null;
  readonly planVsTotalRevenueAtCompletion: number | null;
  readonly planVsTotalBillableTimeAndExpensesAtCompletion: number | null;
  readonly planVsTotalCostAtCompletion: number | null;
  readonly planVsTotalProfitAtCompletion: number | null;
  readonly planVsTotalRevenueProfitAtCompletion: number | null;
  readonly registeredMinutes: number | null;
  readonly forecastTimeToComplete: number | null;
  readonly totalTimeAtCompletion: number | null;
  readonly totalSuggestedRevenue: number | null;
  readonly scopeApprovedMinutes: number | null;
  readonly scopeTotalMinutes: number | null;
  readonly allocationMinutes: number | null;
  readonly invoiced: number | null;
  readonly paid: number | null;
  readonly accruedDeferred: number | null;
  readonly retainerPeriodTargetMinutes: number | null;
  readonly retainerPeriodTargetPrice: number | null;
  readonly recognitionLockedRevenue: number | null;
  readonly recognitionOpenRevenue: number | null;
  readonly unallocatedRevenue: number | null;
  readonly programBudgetValue: number | null;
  readonly recognitionProfit: number | null;
  readonly recognitionProfitPercentage: number | null;
  readonly projectedTotalRevenueVsProjectedTotalBillableValueOfService: number | null;
  readonly projectedTotalRevenueVsProjectedTotalValueOfService: number | null;
  readonly recognitionForecastRevenue: number | null;
  readonly " $fragmentType": "ProjectPortfolioPeriodRow_financialNumbers";
};
export type ProjectPortfolioPeriodRow_financialNumbers$key = {
  readonly " $data"?: ProjectPortfolioPeriodRow_financialNumbers$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPortfolioPeriodRow_financialNumbers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectPortfolioPeriodRow_financialNumbers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billableActualTimeAndExpenses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalActualRevenueRecognition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualRevenueProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualMargin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualRevenueMargin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billablePlannedTimeAndExpenses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedRevenueProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedMargin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedRevenueMargin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billableForecastTimeAndExpensesToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalForecastRevenueToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forecastCostToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forecastProfitToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forecastRevenueProfitToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forecastMarginToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forecastRevenueMarginToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billableTotalTimeAndExpensesAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nonBillableTotalTimeAndExpensesAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allTotalTimeAndExpensesAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalRevenueRecognition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCostAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalProfitAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalRevenueProfitAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalMarginAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalRevenueMarginAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineTimeAndExpenses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineMargin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "baselineMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsBillableActualTimeAndExpenses",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsActualCost",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsActualProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsActualRevenueProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsActualRevenueRecognition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsTotalRevenueAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsTotalBillableTimeAndExpensesAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsTotalCostAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsTotalProfitAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "planVsTotalRevenueProfitAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "registeredMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "forecastTimeToComplete",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalTimeAtCompletion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalSuggestedRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeApprovedMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeTotalMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allocationMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "invoiced",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accruedDeferred",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retainerPeriodTargetMinutes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "retainerPeriodTargetPrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionLockedRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionOpenRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unallocatedRevenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "programBudgetValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionProfit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionProfitPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectedTotalRevenueVsProjectedTotalBillableValueOfService",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectedTotalRevenueVsProjectedTotalValueOfService",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recognitionForecastRevenue",
      "storageKey": null
    }
  ],
  "type": "FinancialNumbers",
  "abstractKey": null
};

(node as any).hash = "0cdd07be8ad5bb5b2c608f153c7c0d8e";

export default node;
